// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--trF1M","error":"error--EP19D"};